export const removeTrailingSlash = (urlString: string) => urlString.replace(/\/+$/, '');
